import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class GrossingTouchSidepanelWrapper extends Vue {
    @Prop(String) readonly sidePanelId!: string
    @Prop(String) readonly sidePanelTitle!: string
    @Prop(String) readonly size!: string
    @Prop(String) readonly footerMainAction!: string
    @Prop(String) readonly footerSecondaryAction!: string
}
